import React from 'react';
import './tailwind.output.css';
import {Helmet} from 'react-helmet'
import HomeImage from './assets/homebg.png';
import safety from './assets/safety.svg';
import star from './assets/star.svg'
import sf from './assets/sf.png'
import sf2 from './assets/sf2.png'
import laser from './assets/laser.svg'
import consultation from './assets/consultation.svg'
import warranty from './assets/warranty.svg'
import cardImage from './assets/projects/CProject1.jpg'
import cardImage2 from './assets/projects/CProject2.jpg'
import clients from './assets/clients.png'
import { Link } from 'react-router-dom';
import Footer from './components/footer';
import Numbers from './components/numbers';


class Home extends React.Component{
  render(){
       const sfimage1 = {
         height: '10rem',
         position: 'absolute',
         top: '-20%',
         left: '-10%'
       }
       const sfimage2 = {
         height: '8rem',
         position: 'absolute',
         bottom: '-20%',
         right: '-10%'
       }

    return(
      <div>
        <Helmet>
            <title>Amit Paintings - Adding Colors to your Home - Professional Home Painters and wall painting services in India</title>
        </Helmet>
        
        <section className="md:px-10 px-2">
          <div className="grid grid-cols-12 py-20 flex items-center gap-6">
            <div className="col-span-12 md:col-span-4 col-start-2 md:col-start-2">
              <span className="tracking-widest uppercase font-thin text-xl">introducing</span>
              <h1 className="uppercase font-black text-4xl tracking-tight">Safe painting services</h1>
              <h2 className="uppercase font-extrabold text-lg">by amit paintings</h2>
              <div className="flex flex-row my-10">
                <div className="flex flex-col justify-start mr-10">
                  <img alt="amit paintings" src={safety} className="h-8 w-8 mb-4"/>
                  <p className="text-as">Safety<br />Protocols</p>
                </div>
                <div className="flex flex-col">
                  <img alt="amit paintings" src={star} className="h-8 w-8 mb-4"/>
                  <p className="text-as">Enhanced<br />SuperVision</p>
                </div>
              </div>
              <Link to="/contact-us" className="bg-ap text-white px-10 py-3 rounded hover:bg-black">Request Free Quote</Link>
            </div>
            <div className="col-span-5 col-end-12 hidden md:block">
              <img alt="amit paintings" src={HomeImage} />
            </div>
          </div>
        </section>
        
        <section className="md:px-10 px-2 pb-aphome">
          <hr className="w-1/2 mx-auto border border-pink-600 my-10"/>
          <Numbers />
          <hr className="w-1/2 mx-auto border border-pink-600 my-10"/>
        </section>

        <section className="md:px-10 px-2">
          <div className="grid grid-cols-12 py-10 gap-6 ">
            <div className="col-span-10 md:col-span-8 col-start-2 md:col-start-3 bg-as px-20 py-10 rounded-lg relative">
              <img alt="amit paintings" src={sf} style={sfimage1} className="hidden md:block" />
              <img alt="amit paintings" src={sf2} style={sfimage2} className="hidden md:block" />
              <h2 className="text-white uppercase text-xl font-bold text-center">Why are we so good?</h2>
              <div className="flex mt-5 justify-between flex-col md:flex-row text-center justify-center">
                <div className="mt-5">
                  <img alt="amit paintings" src={laser} className="w-10 mx-auto md:mr-auto text-center"/>
                  <p className="text-white mt-3">Laser<br />Measurement</p>
                </div>
                <div className="mt-5">
                  <img alt="amit paintings" src={warranty} className="w-10 mx-auto md:mr-auto"/>
                  <p className="text-white mt-3">2 Year*<br />Warranty</p>
                </div>
                <div className="mt-5">
                  <img alt="amit paintings" src={consultation} className="w-10 mx-auto md:mr-auto"/>
                  <p className="text-white mt-3">Free Color<br />Consultation*</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="md:px-10 px-2 pt-aphome">
          <div className="grid grid-cols-12 py-10 gap-6">
            <div className="col-span-12 md:col-span-8 md:col-start-3 bg-white p-10 rounded">
            <h2 className="text-ap uppercase mb-5 font-bold text-xl">our projects</h2>
              <div className="flex">
                <Link to="/projects">
                  <div className="card my-5 mr-5 shadow rounded-lg overflow-hidden hover:bg-gray-200">
                    <img alt="amit paintings" src={cardImage} className="w-full "/>
                    <div className="p-5">
                      <h4 className="text-ap text-lg uppercase font-bold">sark one</h4>
                      <h4 className="text-base">Mokilla, Shankarpally</h4>
                      <h5 className="mt-5 text-xl font-semibold">65 Villas</h5>
                    </div>
                  </div>
                </Link>
                <Link to="/projects">
                  <div className="card my-5 shadow rounded-lg overflow-hidden hover:bg-gray-200">
                    <img alt="amit paintings" src={cardImage2} className="w-full "/>
                    <div className="p-5">
                      <h4 className="text-ap text-lg uppercase font-bold">Splendid aparna</h4>
                      <h4 className="text-base">Kompally</h4>
                      <h5 className="mt-5 text-xl font-semibold">Palm Meadows</h5>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="flex justify-center">
              <Link to="/projects" className="mt-10 bg-ap text-white px-10 py-3 mx-auto rounded hover:bg-black">View Projects</Link>
              </div>
            </div>
          </div>
        </section>

        <section className="md:px-10 px-2">
          <div className="grid grid-cols-12 py-10 gap-8">
              <div className=" col-span-12 md:col-span-10 md:col-start-2 p-10 rounded">
              <h2 className="text-ap uppercase mb-5 font-bold text-xl">our clients</h2>
              <img alt="amit paintings" src={clients} className="w-full"/>
              </div>
          </div>
        </section>

        <Footer />
      </div>      
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/home.js